import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  height: ${({ $small }) => ($small ? "1.5rem" : "3rem")};
  width: ${({ $small }) => ($small ? "1.275rem" : "2.55rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  small?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
